import { useSyncExternalStore } from 'react';
import { getClockSkew, subscribeClockSkew } from '@/lib/authClockSkew';

export function ClockSkewNotice() {
  const detected = useSyncExternalStore(subscribeClockSkew, getClockSkew, () => false);
  if (!detected) return null;
  // AuthShell is fixed-light (a white panel even under .dark), so the notice
  // uses its literal palette rather than theme tokens.
  return (
    <div role="alert" className="mt-5 space-y-2 rounded-lg border border-[#f70000]/40 bg-red-50 p-4 text-sm text-[#0c0c0e]">
      <p className="font-semibold">Check your device’s date and time</p>
      <p>Your clock is out of sync. Correct it before signing in again.</p>
      <p><strong>Windows:</strong> Settings → Time &amp; language → Date &amp; time. Turn on Set time automatically and click Sync now.</p>
      <p><strong>Mac:</strong> System Settings → General → Date &amp; Time (System Preferences → Date &amp; Time on older Macs). Turn on Set time and date automatically.</p>
      <p><strong>iPhone or iPad:</strong> Settings → General → Date &amp; Time. Turn on Set Automatically.</p>
      <p><strong>Android:</strong> Settings → System → Date &amp; time. Turn on Set time automatically.</p>
      <p>On any other device, turn on automatic date and time in its settings.</p>
      <p>Check your time zone, then return here and sign in again. You do not need to reset your password.</p>
    </div>
  );
}

// dark-mode-guard: fixed-light-file -- renders only inside the fixed-light AuthShell panel
